import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 18h-6a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3","key":"svg-0"}],["path",{"d":"M9 18v3h6v-3","key":"svg-1"}],["path",{"d":"M9 6v-3h6v3","key":"svg-2"}],["path",{"d":"M19 16v3","key":"svg-3"}],["path",{"d":"M19 22v.01","key":"svg-4"}]]

const IconDeviceWatchExclamation = createReactComponent('outline', 'device-watch-exclamation', 'DeviceWatchExclamation', __iconNode);

export default IconDeviceWatchExclamation;